import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BxNotification } from '@/app/interfaces/notification.interface';
import { CommonModule } from '@angular/common';
import { AppHeaderComponent } from '../global/appHeader/appHeader.component';
import { LayoutComponent } from '../global/layout/layout.component';
import { NotificationService } from '@/app/services/notification/notification.service';
import { Router } from '@angular/router';
import { MatList, MatListItem } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { DomSanitizer } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NotificationItemComponent } from '../global/notification-item/notification-item.component';
import { NotificationDetailComponent } from './notification-detail/notification-detail.component';
@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    AppHeaderComponent,
    LayoutComponent,
    MatList,
    MatListItem,
    MatCardModule,
    NotificationDetailComponent,
    NotificationItemComponent,
  ],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css',
})
export class NotificationsComponent implements OnInit {
  allNotifications: BxNotification[] = [];

  isSelected = false;
  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.notificationService.getAllNotifications().subscribe({
      next: (response: any) => {
        if (response && response?.data?.length > 0) {
          this.allNotifications = response?.data;
        }
      },
    });
  }

  @Output() notificationSelected: EventEmitter<BxNotification> =
    new EventEmitter<BxNotification>();

  // // Handle the selected notification from child component
  handleNotificationSelected(notification: BxNotification): void {
    this.notificationSelected.emit(notification); // Emit the selected notification
    this.selectedNotification = notification;
  }

  selectedNotification: BxNotification | null = null;

  markAsRead(notification: BxNotification) {
    // TODO: send back request to make notification read
    notification.is_read = true;
  }

  selectNotification(notification: BxNotification) {
    this.selectedNotification = notification;
  }

  // getter
  get parsedSelectedNotificationData() {
    const data = JSON.parse(this.selectedNotification.data);
    return {
      ...data,
      notes: this.sanitizer.bypassSecurityTrustHtml(data?.notes),
    };
  }

  toggleSelected(): void {
    this.isSelected = !this.isSelected;
  }

  onNotificationSelected(notification: BxNotification) {
    this.selectedNotification = notification;
  }
}
